import BaseAPI from '@/apis/base/baseApi';

export default class PApi extends BaseAPI {
  apiName = 'PA';
}
